import { modalHide } from "app/App/actions";
import { FC, useState } from "react";
import { useDispatch } from "react-redux";
import {
    Button,
    LoadingButton,
    Modal,
    ModalActions,
    ModalContent,
    ModalTitle,
    RequestMessage,
} from "ui";
import { IBulkImportTranslationsModal } from "../interfaces";
import useRequest from "api/useRequest";
import { TextField } from "@mui/material";
import { AxiosResponse } from "axios";
import { translateBulkImport } from "../actions";

const MODAL_NAME = "TranslationsBulkImportModal";

const TranslationsBulkImportModal: FC<IBulkImportTranslationsModal> = ({
    project,
    onSuccess,
}) => {
    const dispatch = useDispatch();
    const [jsonText, setJsonText] = useState("");
    const [jsonError, setJsonError] = useState("");
    const { isLoading, message, request, status } = useRequest();

    const handleClose = () => {
        dispatch(modalHide(MODAL_NAME));
    };

    const handleSubmit = () => {
        setJsonError("");

        let parsed: Record<string, string>;
        try {
            parsed = JSON.parse(jsonText);
        } catch {
            setJsonError("Invalid JSON. Please provide a valid JSON object.");
            return;
        }

        if (typeof parsed !== "object" || Array.isArray(parsed)) {
            setJsonError("Invalid JSON. Please provide a valid JSON object.");
            return;
        }

        request(
            translateBulkImport(project, parsed, (response: AxiosResponse) => {
                if (response.status < 300) {
                    handleClose();
                    onSuccess();
                }
            }),
        );
    };

    return (
        <Modal open maxWidth="sm" fullWidth>
            <ModalTitle onClose={handleClose}>
                Bulk import translations
            </ModalTitle>
            <ModalContent>
                {status >= 400 && (
                    <RequestMessage
                        status={status}
                        message={message}
                        sx={{ mb: 2 }}
                    />
                )}
                <TextField
                    autoFocus
                    fullWidth
                    multiline
                    minRows={8}
                    maxRows={20}
                    label="JSON"
                    placeholder='{"key": "value", ...}'
                    value={jsonText}
                    onChange={(e) => {
                        setJsonText(e.target.value);
                        setJsonError("");
                    }}
                    error={!!jsonError}
                    helperText={jsonError}
                />
            </ModalContent>
            <ModalActions>
                <Button
                    onClick={handleClose}
                    color="inherit"
                    variant="text"
                    sx={{ mr: 1 }}
                >
                    Cancel
                </Button>
                <LoadingButton
                    loading={isLoading}
                    variant="outlined"
                    color="secondary"
                    onClick={handleSubmit}
                >
                    Import
                </LoadingButton>
            </ModalActions>
        </Modal>
    );
};

export default TranslationsBulkImportModal;
